import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { useQuote } from "@/lib/useQuote";
import { CartLines, CartTotals } from "./CartLines";

const DrawerTotals = () => {
  const { items, code } = useCart();
  const { quote } = useQuote(items, code);
  return <CartTotals quote={quote} />;
};

export default function CartDrawer() {
  const { open, setOpen, items, count } = useCart();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="bg-[#08080a] border-l border-white/10 text-white w-full sm:max-w-md flex flex-col p-0 [&>button]:text-white" data-testid="cart-drawer">
        <SheetHeader className="px-6 pt-6 pb-4 border-b border-white/10">
          <SheetTitle className="text-white font-display tracking-[0.2em] uppercase text-sm text-left">Your Bag ({count})</SheetTitle>
        </SheetHeader>
        {items.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center gap-6 px-6 text-center" data-testid="cart-drawer-empty">
            <p className="text-zinc-400 text-sm">Your bag is empty.</p>
            <Link to="/shop" onClick={() => setOpen(false)} className="btn-ghost-store" data-testid="cart-drawer-shop-button">Shop the drop</Link>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-6"><CartLines compact /></div>
            <div className="border-t border-white/10 p-6 space-y-5">
              <DrawerTotals />
              <Link to="/checkout" onClick={() => setOpen(false)} className="btn-store w-full" data-testid="cart-drawer-checkout-button">Checkout</Link>
              <Link to="/cart" onClick={() => setOpen(false)} className="block text-center text-xs tracking-[0.2em] uppercase text-zinc-400 hover:text-white" data-testid="cart-drawer-view-cart">View bag</Link>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
